
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.5 12a9.5 9.5 0 1 1-19 0 9.5 9.5 0 0 1 19 0m2.5 0c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12m-7.356-3.119a1 1 0 1 0-1.624-1.167l-3.934 5.474-1.977-1.977a1 1 0 0 0-1.414 1.414l2.81 2.81a1 1 0 0 0 1.519-.124z","fill":"#20bf55"}})])
          )
        }
      }
    